import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ApiService } from 'src/app/api.service';
import { Project } from 'src/app/models/project';

@Component({
  selector: 'modal-change-project-purpose',
  templateUrl: './modal-change-project-purpose.component.html',
  styleUrls: ['./modal-change-project-purpose.component.scss'],
})
export class ModalChangeProjectPurposeComponent implements OnInit {
  purpose?: string;

  constructor(
    public modalRef: MdbModalRef<ModalChangeProjectPurposeComponent>,
    private location: LocationStrategy
  ) {
    history.pushState(null, '', window.location.href);

    this.location.onPopState((event) => {
      this.modalRef.close();
    });
  }

  ngOnInit(): void {}

  switchProjectPurpose() {
    this.modalRef.close(true);
  }
}
